import { Grid, Section } from '@gogame/components';
import React from 'react';

const InfluencersChannelsSection = ({ filters }) => (
  <Section title={'Influencers Channels'}>
    <Grid container spacing={2}>
      {filters.Subscribers && (
        <Grid item xs={4}>
          <filters.Subscribers withFavoriteActions={true} />
        </Grid>
      )}
      {filters.TotalViews && (
        <Grid item xs={4}>
          <filters.TotalViews withFavoriteActions={true} />
        </Grid>
      )}
      {filters.Prices && (
        <Grid item xs={4}>
          <filters.Prices withFavoriteActions={true} />
        </Grid>
      )}
      {filters.SocialMediaPlatforms && (
        <Grid item xs={4}>
          <filters.SocialMediaPlatforms withFavoriteActions={true} />
        </Grid>
      )}
      {filters.Genders && (
        <Grid item xs={4}>
          <filters.Genders withFavoriteActions={true} />
        </Grid>
      )}
      {filters.Briefs && (
        <Grid item xs={4}>
          <filters.Briefs withFavoriteActions={true} />
        </Grid>
      )}
    </Grid>
  </Section>
);

export default InfluencersChannelsSection;
